





















































import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import i18n from "@/i18n";
// types
import { UserGroup } from "@/services/users/types";
import { AzureAdStatus } from "@/store/types";
// validation
import { detailsValidators } from "@/components/users/validators";
import validate from "@/directives/validate";

@Component({
    directives: {
        validate
    }
})
export default class UserGroupDetails extends Vue {
    @Prop() group!: UserGroup;
    @Prop() collapseState!: boolean;
    @Getter("getAzureAdStatus") azureAdStatus!: AzureAdStatus;

    // local state
    localCollapseState = true;
    validators = detailsValidators;

    // lifecycle hooks
    mounted() {
        this.localCollapseState = this.collapseState;
    }

    // methods
    emitData() {
        this.$emit("detailsUpdated", this.group);
    }

    setState(state:boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "UserGroupDetails", state: state });
    }
}
